module.exports = __webpack_public_path__ + "static/media/ic_sort.daedc292.svg";